// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/shark.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes fireAnimation {
  0%, 100% {
    box-shadow: inset 0 10px 10px -10px rgba(255, 99, 71, 0.8), inset 0 -10px 10px -10px rgba(255, 99, 71, 0.8), inset 10px 0 10px -10px rgba(166, 166, 255, 0.8), inset -10px 0 10px -10px rgba(255, 99, 71, 0.8), inset 0 0 10px -10px rgba(255, 99, 71, 0.8);
  }
  50% {
    box-shadow: inset 0 10px 20px -10px rgb(255, 99, 71), inset 0 -10px 20px -10px rgb(255, 99, 71), inset 10px 0 20px -10px rgb(255, 99, 71), inset -10px 0 20px -10px rgb(255, 99, 71), inset 0 0 20px -10px rgb(255, 99, 71);
  }
}
@keyframes blueFireAnimation {
  0%, 100% {
    box-shadow: inset 0 10px 10px -10px rgba(0, 0, 255, 0.8), inset 0 -10px 10px -10px rgba(0, 0, 255, 0.8), inset 10px 0 10px -10px rgba(166, 166, 255, 0.8), inset -10px 0 10px -10px rgba(0, 0, 255, 0.8), inset 0 0 10px -10px rgba(0, 0, 255, 0.8);
  }
  50% {
    box-shadow: inset 0 10px 20px -10px rgb(0, 0, 255), inset 0 -10px 20px -10px rgb(0, 0, 255), inset 10px 0 20px -10px rgb(0, 0, 255), inset -10px 0 20px -10px rgb(0, 0, 255), inset 0 0 20px -10px rgb(0, 0, 255);
  }
}
.grid-view-container {
  display: flex;
  margin: 10px;
  border-radius: 16px;
  height: 80vh;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background: var(--table-color);
}
.grid-view-container .checkbox-container {
  margin: 10px;
}
.grid-view-container .view-container {
  background-color: #f9f9f9;
  padding: 15px;
  width: 40%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #333;
  overflow: auto;
}
.grid-view-container .view-container .file-images {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.grid-view-container .view-container .file-images .image-container {
  text-align: center;
}
.grid-view-container .view-container .file-images .image-container .file-image {
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  will-change: transform, opacity;
}
.grid-view-container .view-container .file-images .image-container .file-image:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.grid-view-container .view-container .file-icons {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.grid-view-container .view-container .file-icons .file-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.grid-view-container .view-container .file-icons .file-item:hover {
  transform: scale(1.05);
}
.grid-view-container .view-container .file-icons .file-item .file-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.grid-view-container .view-container .file-icons .file-item .file-name {
  margin: 0;
  font-size: 14px;
  color: #555;
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.grid-view-container .view-container .content {
  margin: 5px;
  padding: 5px;
  border-radius: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
}
.grid-view-container .view-container .content .text-container {
  margin-left: auto;
}
.grid-view-container .view-container .content .text-container:hover .full-text {
  display: block;
}
.grid-view-container .view-container .content .full-text {
  display: none;
  /* Задайте максимальную ширину для всплывающего блока */
}
.grid-view-container .view-container h2 {
  color: var(--primary-color);
  margin-bottom: 20px;
}
.grid-view-container .view-container .additional-content {
  padding: 10px;
  border-top: 1px solid #ccc;
  margin-top: 20px;
}
.grid-view-container .view-container .additional-content > p {
  color: black;
}
.grid-view-container .view-container .details-actions-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}
.grid-view-container .grid-container {
  height: 80vh;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  /* Основные стили для контейнера поиска и фильтров */
  /* Медиа-запросы для мобильных устройств */
}
.grid-view-container .grid-container .search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  flex-wrap: wrap;
}
.grid-view-container .grid-container .search-container .search-input-container {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1 1;
}
.grid-view-container .grid-container .search-container .search-input-container input[type=text] {
  width: 100%;
  padding: 8px 40px 8px 12px;
  border: 1px solid #ccc;
  border-radius: 200px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}
.grid-view-container .grid-container .search-container .search-input-container .search-icon {
  position: absolute;
  right: 10px;
  font-size: 18px;
  color: #888;
}
.grid-view-container .grid-container .search-container .date-picker-container {
  gap: 10px;
}
.grid-view-container .grid-container .search-container .date-picker-container .date-picker input[type=date] {
  width: 130px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}
.grid-view-container .grid-container .search-container .date-picker-container.desktop-only {
  display: flex;
}
.grid-view-container .grid-container .search-container .filter-toggle {
  display: none;
  /* Показывается только на мобильных устройствах */
}
.grid-view-container .grid-container .filter-content {
  display: flex;
  gap: 10px;
  padding: 10px;
  transition: max-height 0.3s ease;
}
.grid-view-container .grid-container .filter-content .date-picker-container {
  display: flex;
  gap: 10px;
}
.grid-view-container .grid-container .filter-content .date-picker-container.mobile-only {
  display: none;
}
.grid-view-container .grid-container .filter-content .date-picker-container .date-picker input[type=date] {
  width: 150px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}
.grid-view-container .grid-container .filter-content .status-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
}
.grid-view-container .grid-container .filter-content .status-button.overdue {
  background-color: #dc3545;
}
.grid-view-container .grid-container .filter-content .status-button .status-count {
  margin-left: 10px;
  background-color: white;
  color: #007bff;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 768px) {
  .grid-view-container .grid-container .date-picker-container.desktop-only {
    display: none !important;
  }
  .grid-view-container .grid-container .date-picker-container.mobile-only {
    display: flex !important;
    flex-direction: row !important;
    z-index: 1;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .grid-view-container .grid-container .search-container {
    flex-direction: row;
  }
  .grid-view-container .grid-container .filter-content {
    flex-direction: column;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.4s ease, opacity 0.4s ease;
  }
  .grid-view-container .grid-container .filter-toggle {
    display: flex !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    color: black;
    background-color: #fff;
    border: 1px solid #ccc !important;
    border: none;
    border-radius: 200px;
    font-size: 18px;
    transition: background-color 0.3s ease;
  }
  .grid-view-container .grid-container .filter-toggle:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .grid-view-container .grid-container .filter-toggle .arrow {
    margin-left: 8px;
    transition: transform 0.3s ease;
  }
  .grid-view-container .grid-container .filter-toggle .arrow.open {
    transform: rotate(180deg);
  }
  .grid-view-container .grid-container .filter-content.open {
    max-height: 500px;
    opacity: 1;
  }
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  /* Отключить горизонтальный скроллинг */
  border-radius: 8px;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: relative;
  /* Позиционирование для резайзеров */
}
.table-wrapper .table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  /* Устанавливает фиксированное распределение ширины колонок */
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
}
.table-wrapper .table th {
  background-color: #ffffff;
  position: sticky;
  top: 0;
  padding: 14px;
  text-align: center;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  /* Необходимо для псевдоэлемента */
  z-index: 2;
  overflow: hidden;
}
.table-wrapper .table th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  /* Ширина градиента */
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
  /* Не мешает взаимодействию с текстом */
}
.table-wrapper .table th .resizer-area {
  cursor: e-resize;
  position: absolute;
  right: 0;
  top: 10%;
  width: 2px;
  height: 80%;
  z-index: 1;
  transition: background-color 0.2s ease;
  background-color: rgba(0, 0, 0, 0.1);
}
.table-wrapper .table th .resizer-area:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.table-wrapper .table th.selected-column {
  background-color: var(--primary-color);
  color: #ffffff;
}
.table-wrapper .table th.selected-column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  /* Ширина градиента */
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, var(--primary-color) 100%);
  pointer-events: none;
  /* Не мешает взаимодействию с текстом */
}
.table-wrapper .table tr {
  transition: background-color 0.3s ease;
}
.table-wrapper .table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.table-wrapper .table tr:hover {
  background-color: #e9ecef !important;
}
.table-wrapper .table tr.selected {
  background-color: rgba(72, 255, 0, 0.1) !important;
}
.table-wrapper .table tr.highlight-red {
  background-color: rgba(255, 0, 0, 0.1);
}
.table-wrapper .table tr.fire-animation td {
  position: relative;
}
.table-wrapper .table tr.fire-animation td:first-child::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  /* Ширина изображения */
  height: auto;
  z-index: 1;
  background-size: contain;
  background-repeat: no-repeat;
}
.table-wrapper .table td {
  padding: 6px;
  font-size: 16px;
  color: transparent;
  /* Делаем цвет текста прозрачным для отображения градиента */
  background: linear-gradient(to right, #000 0%, #000 80%, rgba(85, 85, 85, 0) 100%);
  /* Градиентный фон от серого к прозрачному */
  -webkit-background-clip: text;
  /* Для Chrome и Safari */
  background-clip: text;
  /* Стандартное свойство для других браузеров */
  position: relative;
  max-width: 30px;
  min-width: 20px;
  overflow: hidden;
  /* Убедитесь, что текст не вылезает из контейнера */
  white-space: nowrap;
  /* Запрещаем перенос строк */
}
.table-wrapper .table td:first-child {
  padding-left: 20px;
}
.table-wrapper .table a {
  color: #007bff;
  /* Пример цветовой переменной */
  text-decoration: none;
  font-weight: 500;
}
.table-wrapper .table a:hover {
  text-decoration: underline;
}
.table-wrapper .table-container {
  overflow-x: auto;
  max-height: 100%;
  position: relative;
}

@media (max-width: 768px) {
  .grid-container {
    width: 100% !important;
  }
  .pagination {
    justify-content: center !important;
  }
  .search-container {
    width: auto;
  }
  .view-container {
    display: none;
    top: 74px;
    right: 0;
    transform: translateX(105%);
    transition: transform 0.5s ease-in-out;
    margin: 0 !important;
    position: fixed;
    height: 90vh;
    width: 100% !important;
    z-index: 1000;
    height: 100%;
    border-radius: 0px !important;
  }
  .view-container.open {
    display: block;
    margin: 0;
    transform: translateX(0);
  }
  .modal .view-container {
    display: block !important;
    position: static !important;
    height: auto !important;
    width: 100% !important;
    transform: none !important;
    transition: none !important;
  }
  .modal .mobile-swipe-area {
    display: none !important;
  }
}
.mobile-arrow {
  position: absolute;
  top: 50%;
  left: -30px;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: left 0.3s ease;
  opacity: 0;
}

.mobile-arrow.show {
  left: 10px;
  opacity: 1;
}

.mobile-arrow.show svg {
  transform: rotate(180deg);
}

.mobile-arrow svg {
  width: 24px;
  height: 24px;
  fill: #000;
  transition: transform 0.3s ease;
}

.mobile-arrow.stroke {
  transition: box-shadow 0.3s ease-in-out;
  box-shadow: 0 0 15px var(--primary-color);
}

.pagination {
  display: flex;
  justify-content: center;
  /* Центрирование пагинации */
  align-items: center;
  gap: 0.5rem;
  /* Меньший промежуток между кнопками */
  padding: 10px 0;
  /* Вертикальный отступ для лучшего размещения */
  background-color: #f8f9fa;
  /* Светлый фон для контраста */
}
.pagination button {
  padding: 4px 9px;
  /* Увеличенные отступы для удобства */
  border: 1px solid #ddd;
  /* Легкий серый цвет границы */
  border-radius: 25px;
  /* Более округлые углы */
  background-color: var(--primary-color);
  /* Цвет кнопок по умолчанию */
  color: #fff;
  /* Белый цвет текста */
  font-size: 14px;
  /* Немного увеличенный размер шрифта */
  font-weight: 500;
  /* Полужирное начертание для лучшей видимости */
  cursor: pointer;
  transition: all 0.3s ease;
  /* Плавные переходы для всех свойств */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Тень для объема */
}
.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  /* Чуть меньше прозрачности для неактивных кнопок */
  background-color: #d6d6d6;
  /* Светлый цвет для неактивных кнопок */
  border-color: #ccc;
  /* Соответствующий цвет границы */
  color: #777;
  /* Тусклый цвет текста */
}
.pagination button:not(:disabled):hover {
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.4);
  /* Увеличенная тень при наведении */
  color: #000;
  background-color: #ddd;
}
.pagination button:not(:disabled):focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/grid-view.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAmBhB;EAEE;IAEE,2PAAA;EAnBF;EAwBA;IACE,2NAAA;EAtBF;AACF;AA2BA;EAEE;IAEE,mPAAA;EA3BF;EAgCA;IACE,iNAAA;EA9BF;AACF;AAmCA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,8BAtDY;AAqBd;AAmCE;EACE,YAAA;AAjCJ;AAoCE;EACE,yBAjDoB;EAkDpB,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wCAAA;EACA,WAlES;EAmET,cAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAlCN;AAoCM;EACE,kBAAA;AAlCR;AAoCQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kDAAA;EACA,+BAAA;AAlCV;AAoCU;EACE,sBAAA;EACA,YAAA;AAlCZ;AAwCI;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAtCN;AAwCM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AAtCR;AAwCQ;EACE,sBAAA;AAtCV;AAyCQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAvCV;AA2CQ;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAzCV;AA8CI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;AA5CN;AA8CM;EACE,iBAAA;AA5CR;AA+CM;EACE,cAAA;AA7CR;AAgDM;EACE,aAAA;EACA,uDAAA;AA9CR;AAkDI;EACE,2BA7JU;EA8JV,mBAAA;AAhDN;AAmDI;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;AAjDN;AAmDM;EACE,YAAA;AAjDR;AAqDI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAnDN;AAuDE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EAEA,oDAAA;EAoHA,0CAAA;AAzKJ;AAsDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AApDN;AAsDM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AApDR;AAsDQ;EACE,WAAA;EACA,0BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AApDV;AAuDQ;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AArDV;AAyDM;EACE,SAAA;AAvDR;AA0DU;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AAxDZ;AA+DQ;EACE,aAAA;AA7DV;AAmEM;EACE,aAAA;EACA,iDAAA;AAjER;AAqEI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AAnEN;AAqEM;EACE,aAAA;EACA,SAAA;AAnER;AAqEQ;EACE,aAAA;AAnEV;AAuEU;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AArEZ;AA2EM;EACE,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,sCAAA;EACA,kBAAA;AA1ER;AA4EQ;EACE,yBAAA;AA1EV;AA6EQ;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA3EV;AAkFI;EAEI;IACE,wBAAA;EAjFR;EAoFM;IACE,wBAAA;IACA,8BAAA;IACA,UAAA;IACA,8BAAA;IACA,kBAAA;IACA,0CAAA;IACA,kBAAA;IACA,wCAAA;EAlFR;EAsFI;IACE,mBAAA;EApFN;EAuFI;IACE,sBAAA;IACA,yBAAA;IACA,kBAAA;IACA,wCAAA;IACA,aAAA;IACA,aAAA;IACA,UAAA;IACA,mDAAA;EArFN;EAwFI;IACE,wBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,iCAAA;IACA,YAAA;IACA,oBAAA;IACA,eAAA;IACA,sCAAA;EAtFN;EAwFM;IACE,wCAAA;EAtFR;EAyFM;IACE,gBAAA;IACA,+BAAA;EAvFR;EAyFQ;IACE,yBAAA;EAvFV;EA4FI;IACE,iBAAA;IACA,UAAA;EA1FN;AACF;;AAiGA;EACE,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AA9FF;AAgGE;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AA9FJ;AAgGI;EACE,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,UAAA;EACA,gBAAA;AA9FN;AAgGM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,yFAAA;EACA,oBAAA;EACA,uCAAA;AA9FR;AAiGM;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,sCAAA;EACA,oCAAA;AA/FR;AAiGQ;EACE,oCAAA;AA/FV;AAmGM;EACE,sCAvbQ;EAwbR,cAAA;AAjGR;AAmGQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,2FAAA;EACA,oBAAA;EACA,uCAAA;AAjGV;AAsGI;EACE,sCAAA;AApGN;AAsGM;EACE,yBAAA;AApGR;AAuGM;EACE,oCAAA;AArGR;AAwGM;EACE,kDAAA;AAtGR;AAyGM;EACE,sCAAA;AAvGR;AA2GQ;EACE,kBAAA;AAzGV;AA4GQ;EACE,gDAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;EACA,4BAAA;AA1GV;AA+GI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,4DAAA;EACA,kFAAA;EACA,4CAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,mBAAA;EACA,4BAAA;AA7GN;AAgHI;EACE,kBAAA;AA9GN;AAiHI;EACE,cAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;AA/GN;AAkHI;EACE,0BAAA;AAhHN;AAoHE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAlHJ;;AAuHA;EACE;IACE,sBAAA;EApHF;EAuHA;IACE,kCAAA;EArHF;EAwHA;IACE,WAAA;EAtHF;EAyHA;IACE,aAAA;IACA,SAAA;IACA,QAAA;IACA,2BAAA;IACA,sCAAA;IACA,oBAAA;IACA,eAAA;IACA,YAAA;IACA,sBAAA;IACA,aAAA;IACA,YAAA;IACA,6BAAA;EAvHF;EA0HA;IACE,cAAA;IACA,SAAA;IACA,wBAAA;EAxHF;EA2HA;IACE,yBAAA;IACA,2BAAA;IACA,uBAAA;IACA,sBAAA;IACA,0BAAA;IACA,2BAAA;EAzHF;EA4HA;IACE,wBAAA;EA1HF;AACF;AA6HA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;AA3HF;;AA8HA;EACE,UAAA;EACA,UAAA;AA3HF;;AA8HA;EACE,yBAAA;AA3HF;;AA8HA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;AA3HF;;AA8HA;EACE,uCAAA;EACA,yCAAA;AA3HF;;AA8HA;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;EACA,+CAAA;EACA,yBAAA;EACA,8BAAA;AA3HF;AA6HE;EACE,gBAAA;EACA,qCAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;EACA,sCApoBY;EAqoBZ,6BAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,+CAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;EACA,wCAAA;EACA,oBAAA;AA3HJ;AA6HI;EACE,mBAAA;EACA,YAAA;EACA,mDAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,wBAAA;AA3HN;AA8HI;EACE,wCAAA;EACA,mCAAA;EACA,WAAA;EACA,sBAAA;AA5HN;AA+HI;EACE,aAAA;AA7HN","sourcesContent":["$secondary-color: var(--secondary-color);\n$primary-color: var(--primary-color);\n$background-color: var(--background-color);\n$table-color: var(--table-color);\n$hover-background-color: #e0e0e0;\n$text-color: #333;\n$light-background-color: #f9f9f9;\n$border-color: #ccc;\n$table-primary-color: rgb(16, 112, 49);\n$table-hover-color: #f0f0f0;\n$fire-color: rgba(255, 99, 71, 0.8);\n$fire-color-intense: rgba(255, 99, 71, 1);\n$blue-fire-color: rgba(0, 0, 255, 0.8);\n$blue-fire-color-intense: rgba(0, 0, 255, 1);\n$blue-fire-color-light: rgba(166, 166, 255, 0.8);\n$view-background-color: #f9f9f9;\n$detail-background-color: #fff;\n$detail-border-radius: 4px;\n\n@keyframes fireAnimation {\n\n  0%,\n  100% {\n    box-shadow: inset 0 10px 10px -10px $fire-color, inset 0 -10px 10px -10px $fire-color,\n      inset 10px 0 10px -10px $blue-fire-color-light, inset -10px 0 10px -10px $fire-color,\n      inset 0 0 10px -10px $fire-color;\n  }\n\n  50% {\n    box-shadow: inset 0 10px 20px -10px $fire-color-intense, inset 0 -10px 20px -10px $fire-color-intense,\n      inset 10px 0 20px -10px $fire-color-intense, inset -10px 0 20px -10px $fire-color-intense,\n      inset 0 0 20px -10px $fire-color-intense;\n  }\n}\n\n@keyframes blueFireAnimation {\n\n  0%,\n  100% {\n    box-shadow: inset 0 10px 10px -10px $blue-fire-color, inset 0 -10px 10px -10px $blue-fire-color,\n      inset 10px 0 10px -10px $blue-fire-color-light, inset -10px 0 10px -10px $blue-fire-color,\n      inset 0 0 10px -10px $blue-fire-color;\n  }\n\n  50% {\n    box-shadow: inset 0 10px 20px -10px $blue-fire-color-intense, inset 0 -10px 20px -10px $blue-fire-color-intense,\n      inset 10px 0 20px -10px $blue-fire-color-intense, inset -10px 0 20px -10px $blue-fire-color-intense,\n      inset 0 0 20px -10px $blue-fire-color-intense;\n  }\n}\n\n.grid-view-container {\n  display: flex;\n  margin: 10px;\n  border-radius: 16px;\n  height: 80vh;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  background: $table-color;\n\n  .checkbox-container {\n    margin: 10px;\n  }\n\n  .view-container {\n    background-color: $view-background-color;\n    padding: 15px;\n    width: 40%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    color: $text-color;\n    overflow: auto;\n\n    .file-images {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      gap: 12px;\n      margin-top: 12px;\n\n      .image-container {\n        text-align: center;\n\n        .file-image {\n          width: 100%;\n          height: auto;\n          cursor: pointer;\n          border-radius: 8px;\n          transition: transform 0.3s ease, opacity 0.3s ease;\n          will-change: transform, opacity;\n\n          &:hover {\n            transform: scale(1.05);\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .file-icons {\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n\n      .file-item {\n        display: flex;\n        align-items: center;\n        margin-bottom: 8px;\n        cursor: pointer;\n        transition: transform 0.3s ease;\n\n        &:hover {\n          transform: scale(1.05);\n        }\n\n        .file-icon {\n          width: 24px;\n          height: 24px;\n          margin-right: 12px;\n\n        }\n\n        .file-name {\n          margin: 0;\n          font-size: 14px;\n          color: #555;\n          max-width: calc(100% - 40px);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .content {\n      margin: 5px;\n      padding: 5px;\n      border-radius: 16px;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      display: flex;\n\n      .text-container {\n        margin-left: auto;\n      }\n\n      .text-container:hover .full-text {\n        display: block;\n      }\n\n      .full-text {\n        display: none;\n        /* Задайте максимальную ширину для всплывающего блока */\n      }\n    }\n\n    h2 {\n      color: $primary-color;\n      margin-bottom: 20px;\n    }\n\n    .additional-content {\n      padding: 10px;\n      border-top: 1px solid $border-color;\n      margin-top: 20px;\n\n      &>p {\n        color: darken($text-color, 20%);\n      }\n    }\n\n    .details-actions-container {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      margin-top: 10px;\n    }\n  }\n\n  .grid-container {\n    height: 80vh;\n    width: 100%; //70%\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n\n    /* Основные стили для контейнера поиска и фильтров */\n    .search-container {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 10px;\n      flex-wrap: wrap;\n\n      .search-input-container {\n        display: flex;\n        align-items: center;\n        position: relative;\n        flex: 1;\n\n        input[type=\"text\"] {\n          width: 100%;\n          padding: 8px 40px 8px 12px;\n          border: 1px solid #ccc;\n          border-radius: 200px;\n          font-size: 16px;\n          outline: none;\n          transition: border-color 0.3s ease;\n        }\n\n        .search-icon {\n          position: absolute;\n          right: 10px;\n          font-size: 18px;\n          color: #888;\n        }\n      }\n\n      .date-picker-container {\n        gap: 10px;\n\n        .date-picker {\n          input[type=\"date\"] {\n            width: 130px;\n            padding: 8px;\n            border: 1px solid #ccc;\n            border-radius: 20px;\n            font-size: 16px;\n            outline: none;\n            transition: border-color 0.3s ease;\n\n          }\n        }\n\n\n\n        &.desktop-only {\n          display: flex;\n        }\n\n\n      }\n\n      .filter-toggle {\n        display: none;\n        /* Показывается только на мобильных устройствах */\n      }\n    }\n\n    .filter-content {\n      display: flex;\n      gap: 10px;\n      padding: 10px;\n      transition: max-height 0.3s ease;\n\n      .date-picker-container {\n        display: flex;\n        gap: 10px;\n\n        &.mobile-only {\n          display: none;\n        }\n\n        .date-picker {\n          input[type=\"date\"] {\n            width: 150px;\n            padding: 8px;\n            border: 1px solid #ccc;\n            border-radius: 20px;\n            font-size: 16px;\n            outline: none;\n            transition: border-color 0.3s ease;\n\n          }\n        }\n      }\n\n      .status-button {\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        position: relative;\n\n        &.overdue {\n          background-color: #dc3545;\n        }\n\n        .status-count {\n          margin-left: 10px;\n          background-color: white;\n          color: #007bff;\n          border-radius: 12px;\n          padding: 2px 8px;\n          font-size: 14px;\n          font-weight: bold;\n        }\n\n      }\n    }\n\n    /* Медиа-запросы для мобильных устройств */\n    @media (max-width: 768px) {\n      .date-picker-container {\n        &.desktop-only {\n          display: none !important;\n        }\n\n        &.mobile-only {\n          display: flex !important;\n          flex-direction: row !important;\n          z-index: 1;\n          justify-content: space-between;\n          padding: 10px 15px;\n          background-color: rgba(255, 255, 255, 0.9);\n          border-radius: 8px;\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        }\n      }\n\n      .search-container {\n        flex-direction: row;\n      }\n\n      .filter-content {\n        flex-direction: column;\n        background-color: #f9f9f9;\n        border-radius: 8px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        padding: 15px;\n        max-height: 0;\n        opacity: 0;\n        transition: max-height 0.4s ease, opacity 0.4s ease;\n      }\n\n      .filter-toggle {\n        display: flex !important;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        padding: 10px;\n        color: black;\n        background-color: #fff;\n        border: 1px solid #ccc !important;\n        border: none;\n        border-radius: 200px;\n        font-size: 18px;\n        transition: background-color 0.3s ease;\n\n        &:hover {\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        }\n\n        .arrow {\n          margin-left: 8px;\n          transition: transform 0.3s ease;\n\n          &.open {\n            transform: rotate(180deg);\n          }\n        }\n      }\n\n      .filter-content.open {\n        max-height: 500px;\n        opacity: 1;\n      }\n    }\n\n\n  }\n}\n\n.table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  /* Отключить горизонтальный скроллинг */\n  border-radius: 8px;\n  height: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  position: relative;\n  /* Позиционирование для резайзеров */\n\n  .table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    table-layout: fixed;\n    /* Устанавливает фиксированное распределение ширины колонок */\n    width: 100%;\n    background-color: #ffffff;\n    border-radius: 8px;\n\n    th {\n      background-color: #ffffff;\n      position: sticky;\n      top: 0;\n      padding: 14px;\n      text-align: center;\n      font-weight: bold;\n      color: #333;\n      white-space: nowrap;\n      overflow: hidden;\n      position: relative;\n      /* Необходимо для псевдоэлемента */\n      z-index: 2;\n      overflow: hidden;\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 20px;\n        /* Ширина градиента */\n        height: 100%;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);\n        pointer-events: none;\n        /* Не мешает взаимодействию с текстом */\n      }\n\n      .resizer-area {\n        cursor: e-resize;\n        position: absolute;\n        right: 0;\n        top: 10%;\n        width: 2px;\n        height: 80%;\n        z-index: 1;\n        transition: background-color 0.2s ease;\n        background-color: rgba(0, 0, 0, 0.1);\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.2);\n        }\n      }\n\n      &.selected-column {\n        background-color: $primary-color;\n        color: #ffffff;\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          width: 20px;\n          /* Ширина градиента */\n          height: 100%;\n          background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, $primary-color 100%);\n          pointer-events: none;\n          /* Не мешает взаимодействию с текстом */\n        }\n      }\n    }\n\n    tr {\n      transition: background-color 0.3s ease;\n\n      &:nth-child(even) {\n        background-color: #f9f9f9;\n      }\n\n      &:hover {\n        background-color: #e9ecef !important;\n      }\n\n      &.selected {\n        background-color: rgba(72, 255, 0, 0.1) !important;\n      }\n\n      &.highlight-red {\n        background-color: rgba(255, 0, 0, 0.1);\n      }\n\n      &.fire-animation {\n        td {\n          position: relative;\n        }\n\n        td:first-child::before {\n          content: url('../../assets/images/shark.gif');\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 50px;\n          /* Ширина изображения */\n          height: auto;\n          z-index: 1;\n          background-size: contain;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    td {\n      padding: 6px;\n      font-size: 16px;\n      color: transparent;\n      /* Делаем цвет текста прозрачным для отображения градиента */\n      background: linear-gradient(to right, #000 0%, #000 80%, rgba(85, 85, 85, 0) 100%);\n      /* Градиентный фон от серого к прозрачному */\n      -webkit-background-clip: text;\n      /* Для Chrome и Safari */\n      background-clip: text;\n      /* Стандартное свойство для других браузеров */\n      position: relative;\n      max-width: 30px;\n      min-width: 20px;\n      overflow: hidden;\n      /* Убедитесь, что текст не вылезает из контейнера */\n      white-space: nowrap;\n      /* Запрещаем перенос строк */\n    }\n\n    td:first-child {\n      padding-left: 20px;\n    }\n\n    a {\n      color: #007bff;\n      /* Пример цветовой переменной */\n      text-decoration: none;\n      font-weight: 500;\n    }\n\n    a:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .table-container {\n    overflow-x: auto;\n    max-height: 100%;\n    position: relative;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .grid-container {\n    width: 100% !important;\n  }\n\n  .pagination {\n    justify-content: center !important;\n  }\n\n  .search-container {\n    width: auto;\n  }\n\n  .view-container {\n    display: none;\n    top: 74px;\n    right: 0;\n    transform: translateX(105%);\n    transition: transform 0.5s ease-in-out;\n    margin: 0 !important;\n    position: fixed;\n    height: 90vh;\n    width: 100% !important;\n    z-index: 1000;\n    height: 100%;\n    border-radius: 0px !important;\n  }\n\n  .view-container.open {\n    display: block;\n    margin: 0;\n    transform: translateX(0);\n  }\n\n  .modal .view-container {\n    display: block !important;\n    position: static !important;\n    height: auto !important;\n    width: 100% !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .modal .mobile-swipe-area {\n    display: none !important;\n  }\n}\n\n.mobile-arrow {\n  position: absolute;\n  top: 50%;\n  left: -30px;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: left 0.3s ease;\n  opacity: 0;\n}\n\n.mobile-arrow.show {\n  left: 10px;\n  opacity: 1;\n}\n\n.mobile-arrow.show svg {\n  transform: rotate(180deg);\n}\n\n.mobile-arrow svg {\n  width: 24px;\n  height: 24px;\n  fill: #000;\n  transition: transform 0.3s ease;\n}\n\n.mobile-arrow.stroke {\n  transition: box-shadow 0.3s ease-in-out;\n  box-shadow: 0 0 15px $primary-color;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  /* Центрирование пагинации */\n  align-items: center;\n  gap: 0.5rem;\n  /* Меньший промежуток между кнопками */\n  padding: 10px 0;\n  /* Вертикальный отступ для лучшего размещения */\n  background-color: #f8f9fa;\n  /* Светлый фон для контраста */\n\n  button {\n    padding: 4px 9px;\n    /* Увеличенные отступы для удобства */\n    border: 1px solid #ddd;\n    /* Легкий серый цвет границы */\n    border-radius: 25px;\n    /* Более округлые углы */\n    background-color: $primary-color;\n    /* Цвет кнопок по умолчанию */\n    color: #fff;\n    /* Белый цвет текста */\n    font-size: 14px;\n    /* Немного увеличенный размер шрифта */\n    font-weight: 500;\n    /* Полужирное начертание для лучшей видимости */\n    cursor: pointer;\n    transition: all 0.3s ease;\n    /* Плавные переходы для всех свойств */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    /* Тень для объема */\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n      /* Чуть меньше прозрачности для неактивных кнопок */\n      background-color: #d6d6d6;\n      /* Светлый цвет для неактивных кнопок */\n      border-color: #ccc;\n      /* Соответствующий цвет границы */\n      color: #777;\n      /* Тусклый цвет текста */\n    }\n\n    &:not(:disabled):hover {\n      box-shadow: 0 0px 4px rgba(0, 0, 0, 0.4);\n      /* Увеличенная тень при наведении */\n      color: #000;\n      background-color: #ddd;\n    }\n\n    &:not(:disabled):focus {\n      outline: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
